import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { FHEListingHeader } from 'data/components';
import renderEnvComponent from 'data/common/renderEnvComponent';

class DetailExpansionPanel extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        headerTitle: PropTypes.string.isRequired,
        headerSvg: PropTypes.object.isRequired
    };

    render() {
        const { classes, children, headerTitle, headerSvg } = this.props;
        return (
            <div className={classes.detailPanelContainer}>
                <FHEListingHeader title={headerTitle} svgimage={headerSvg} />
                <div className={classes.detailPanel}>{children}</div>
            </div>
        );
    }
}

const styles = () => ({
    detailPanelContainer: {
        marginTop: 10,
        marginBottom: 10
    },
    detailPanel: {
        marginTop: -7
    }
});

export default withRouter(
    renderEnvComponent('scenes/Products/components/ProductModule/DetailExpansionPanel', withStyles(styles, { withTheme: true })(DetailExpansionPanel))
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/ProductModule/DetailExpansionPanel.js